<div class="d-flex flex-column min-vh-100">
  <app-header-buscador></app-header-buscador>
  <div class="position-relative">
    <ngx-gallery
      id="gallery-slide"
      #gallerySlide
      [options]="galleryOptions"
      [images]="gallerySlider"
      *ngIf="gallerySlider.length > 0"
    >
    </ngx-gallery>
    <div class="position-absolute hayMas" *ngIf="gallerySlider.length > 0">
      <a
        class="btn btn-primary rounded-circle d-flex justify-content-center align-items-center p-0"
        style="width: 40px; height: 40px"
        [style]="
          'background-color:' +
          config?.primaryColor +
          ' !important; border-color:' +
          config?.primaryColor +
          ' !important'
        "
        (click)="scrollToElement('main-container')"
      >
        <i class="fa fa-chevron-down"></i>
      </a>
    </div>
  </div>
  <ng-container *ngIf="config?.theme === 1">
    <section id="main-container" class="container-lg container-md container-xl pt-2">
      <h1 class="titulo" [style]="'color:' + config?.primaryColor + ' !important; font-weight: 500'">
        {{ project?.name }}
      </h1>
      <h6 class="estado">
        {{ project?.location }}
      </h6>
      <h3 class="operation" [style]="'color:' + config?.primaryColor + ' !important;'">Proyecto</h3>
      <div class="box-container">
        <swiper class="swiper-container" [config]="configSwal">
          <div *ngFor="let img of project?.Images" class="swiper-slide">
            <img [src]="img.url" alt="" />
          </div>
        </swiper>
      </div>

      <hr />

      <div class="row py-5">
        <!-- Descripción -->
        <div class="col-12 col-md-6">
          <h3 class="column-title mrt-0" style="text-wrap: balance">
            {{ project?.name }}
          </h3>
          <p style="text-wrap: pretty" [style.white-space]="'pre-line'">
            {{ project?.description }}
          </p>
        </div>
        <div class="col-12 col-md-6">
          <h3>Lo que ofrece este proyecto</h3>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div *ngFor="let amenity of amenities" class="m-1">
                <img [src]="'assets/icon/IconBlue/' + amenity.amenity.icon" height="18" width="18" />
                &nbsp;
                <div [innerHTML]="amenity.amenity_id == 6 ? amenity.cantidad + '&nbsp;' : ''" class="amenity"></div>

                <div [innerHTML]="amenity.amenity.name" class="amenity"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 3 Propiedades del proyecto (tomadas al azar) -->
      <div class="row">
        <div class="col-12 col-md-4 d-flex" *ngFor="let estate of random_estates">
          <div class="card flex-grow-1">
            <img
              class="card-img-top img-fluid"
              style="height: 15rem; object-fit: cover"
              [src]="
                estate?.files?.length > 0
                  ? estate?.files[0]?.url ?? 'assets/images/noImage.png'
                  : 'assets/images/noImage.png'
              "
              (error)="estate?.files[0].url = 'assets/images/noImage.png'"
              alt="Card image cap"
            />
            <div class="card-body">
              <h5 class="card-title">{{ estate.title }}</h5>
              <p class="card-text">
                {{ estate.description }}
              </p>
              <a
                (click)="goToDetalles(estate.property.id)"
                class="btn btn-primary"
                [style]="
                  'border-color:' +
                  config?.primaryColor +
                  ' !important;background-color:' +
                  config?.primaryColor +
                  ' !important;color:' +
                  config.secondaryColor +
                  ' !important;'
                "
                >Ver más</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Google maps -->
      <div class="row mt-5">
        <div class="col-12">
          <h3 class="column-title mb-1">Ubicación</h3>
          <div id="map"></div>
        </div>
      </div>

      <!-- Slider de layouts -->
      <div class="row mt-5">
        <div class="col-lg-12">
          <h3 class="mb-1">PLANOS DEL PROYECTO</h3>
        </div>
        <div class="col-lg-12">
          <app-building [config]="config"></app-building>
        </div>
        <div class="col-lg-12" *ngIf="building.length <= 0">
          <div class="row">
            <div class="buttons-lay pl-3" *ngFor="let layout of layouts">
              <button
                type="button"
                class="btn"
                [style]="
                  'border-color:' +
                  config?.primaryColor +
                  ' !important;' +
                  'background-color:' +
                  (layoutSelected === layout.id ? config?.primaryColor : 'transparent') +
                  ' !important;' +
                  'color:' +
                  (layoutSelected === layout.id ? config.secondaryColor : config?.primaryColor) +
                  ' !important;'
                "
                (click)="changeLay(layout.id)"
              >
                {{ layout.name }}
              </button>
            </div>
          </div>
          <app-layout *ngIf="building.length <= 0"></app-layout>
        </div>
      </div>

      <!-- Sección de propiedades -->
      <div class="row mt-5 justify-content-center">
        <div class="col-lg-12">
          <h3 class="column-title mb-1">Propiedades del Proyecto</h3>
        </div>
        <div class="col-lg-12">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th (click)="sortData('title')" style="cursor: pointer">
                    Nombre
                    <i
                      class="fa fa-sort"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      aria-hidden="true"
                    ></i>
                  </th>
                  <th (click)="sortData('type')" style="cursor: pointer">
                    Tipo
                    <i
                      class="fa fa-sort"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      aria-hidden="true"
                    ></i>
                  </th>
                  <th (click)="sortData('price')" style="cursor: pointer">
                    Precio
                    <i
                      class="fa fa-sort"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      aria-hidden="true"
                    ></i>
                  </th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let estate of estates">
                  <td>{{ estate.title }}</td>
                  <td>{{ estate.type }}</td>
                  <td>
                    {{ estate.price ? (estate.price | currency) : "POR DEFINIR..." }}
                  </td>
                  <td>
                    <a
                      (click)="goToDetalles(estate.property.id)"
                      class="btn btn-outline-primary btn-sm"
                      [style]="
                        'border-color:' +
                        config?.primaryColor +
                        ' !important;' +
                        'background-color: transparent !important;' +
                        'color:' +
                        config?.primaryColor +
                        ' !important;'
                      "
                    >
                      <i class="fa fa-eye"></i>
                      Ver propiedad
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
            <div class="d-flex justify-content-between float-right m-1">
              <ngb-pagination
                *ngIf="estates?.length > 0"
                [collectionSize]="sizeTable"
                [maxSize]="3"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="getPageData()"
                aria-label="Cambiar página"
              >
                <ng-template ngbPaginationPrevious
                  ><span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder text-primary'"></span>
                </ng-template>
                <ng-template ngbPaginationNext
                  ><span
                    [data-feather]="'chevron-right'"
                    [size]="18"
                    [class]="'font-weight-bolder text-primary'"
                  ></span>
                </ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
  <ng-container *ngIf="config?.theme === 2">
    <section id="main-container" class="container-lg container-md container-xl pt-2">
      <h1 class="titulo" [style]="'color:' + config?.primaryColor + ' !important; font-weight: 500'">
        {{ project?.name }}
      </h1>
      <h6 class="estado">
        {{ project?.location }}
      </h6>
      <h3 class="operation" [style]="'color:' + config?.primaryColor + ' !important;'">Proyecto</h3>
      <div class="box-container">
        <swiper class="swiper-container" [config]="configSwal">
          <div *ngFor="let img of project?.Images" class="swiper-slide">
            <img [src]="img.url" alt="" />
          </div>
        </swiper>
      </div>

      <hr />

      <div class="row py-5">
        <!-- Descripción -->
        <div class="col-12 col-md-6">
          <h3 class="column-title mrt-0" style="text-wrap: balance">
            {{ project?.name }}
          </h3>
          <p style="text-wrap: pretty" [style.white-space]="'pre-line'">
            {{ project?.description }}
          </p>
        </div>
        <div class="col-12 col-md-6">
          <h3>Lo que ofrece este proyecto</h3>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div *ngFor="let amenity of amenities" class="m-1">
                <img [src]="'assets/icon/IconBlue/' + amenity.amenity.icon" height="18" width="18" />
                &nbsp;
                <div [innerHTML]="amenity.amenity_id == 6 ? amenity.cantidad + '&nbsp;' : ''" class="amenity"></div>

                <div [innerHTML]="amenity.amenity.name" class="amenity"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 3 Propiedades del proyecto (tomadas al azar) -->
      <div class="row">
        <div class="col-12 col-md-4 d-flex" *ngFor="let estate of random_estates">
          <div class="card flex-grow-1">
            <img
              class="card-img-top img-fluid"
              style="height: 15rem; object-fit: cover"
              [src]="
                estate?.files?.length > 0
                  ? estate?.files[0]?.url ?? 'assets/images/noImage.png'
                  : 'assets/images/noImage.png'
              "
              (error)="estate?.files[0].url = 'assets/images/noImage.png'"
              alt="Card image cap"
            />
            <div class="card-body">
              <h5 class="card-title">{{ estate.title }}</h5>
              <p class="card-text">
                {{ estate.description }}
              </p>
              <a
                (click)="goToDetalles(estate.property.id)"
                class="btn btn-primary"
                [style]="
                  'border-color:' +
                  config?.primaryColor +
                  ' !important;background-color:' +
                  config?.primaryColor +
                  ' !important;color:' +
                  config.secondaryColor +
                  ' !important;'
                "
                >Ver más</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Google maps -->
      <div class="row mt-5">
        <div class="col-12">
          <h3 class="column-title mb-1">Ubicación</h3>
          <div id="map"></div>
        </div>
      </div>

      <!-- Slider de layouts -->
      <div class="row mt-5">
        <div class="col-lg-12">
          <h3 class="mb-1">PLANOS DEL PROYECTO</h3>
        </div>
        <div class="col-lg-12">
          <app-building [config]="config"></app-building>
        </div>
        <div class="col-lg-12" *ngIf="building.length <= 0">
          <div class="row">
            <div class="buttons-lay pl-3" *ngFor="let layout of layouts">
              <button
                type="button"
                class="btn"
                [style]="
                  'border-color:' +
                  config?.primaryColor +
                  ' !important;' +
                  'background-color:' +
                  (layoutSelected === layout.id ? config?.primaryColor : 'transparent') +
                  ' !important;' +
                  'color:' +
                  (layoutSelected === layout.id ? config.secondaryColor : config?.primaryColor) +
                  ' !important;'
                "
                (click)="changeLay(layout.id)"
              >
                {{ layout.name }}
              </button>
            </div>
          </div>
          <app-layout *ngIf="building.length <= 0"></app-layout>
        </div>
      </div>

      <!-- Sección de propiedades -->
      <div class="row mt-5 justify-content-center">
        <div class="col-lg-12">
          <h3 class="column-title mb-1">Propiedades del Proyecto</h3>
        </div>
        <div class="col-lg-12">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th (click)="sortData('title')" style="cursor: pointer">
                    Nombre
                    <i
                      class="fa fa-sort"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      aria-hidden="true"
                    ></i>
                  </th>
                  <th (click)="sortData('type')" style="cursor: pointer">
                    Tipo
                    <i
                      class="fa fa-sort"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      aria-hidden="true"
                    ></i>
                  </th>
                  <th (click)="sortData('price')" style="cursor: pointer">
                    Precio
                    <i
                      class="fa fa-sort"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      aria-hidden="true"
                    ></i>
                  </th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let estate of estates">
                  <td>{{ estate.title }}</td>
                  <td>{{ estate.type }}</td>
                  <td>
                    {{ estate.price ? (estate.price | currency) : "POR DEFINIR..." }}
                  </td>
                  <td>
                    <a
                      (click)="goToDetalles(estate.property.id)"
                      class="btn btn-outline-primary btn-sm"
                      [style]="
                        'border-color:' +
                        config?.primaryColor +
                        ' !important;' +
                        'background-color: transparent !important;' +
                        'color:' +
                        config?.primaryColor +
                        ' !important;'
                      "
                    >
                      <i class="fa fa-eye"></i>
                      Ver propiedad
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
            <div class="d-flex justify-content-between float-right m-1">
              <ngb-pagination
                *ngIf="estates?.length > 0"
                [collectionSize]="sizeTable"
                [maxSize]="3"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="getPageData()"
                aria-label="Cambiar página"
              >
                <ng-template ngbPaginationPrevious
                  ><span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder text-primary'"></span>
                </ng-template>
                <ng-template ngbPaginationNext
                  ><span
                    [data-feather]="'chevron-right'"
                    [size]="18"
                    [class]="'font-weight-bolder text-primary'"
                  ></span>
                </ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
  <ng-container *ngIf="config?.theme === 3">
    <section id="main-container" class="container-lg container-md container-xl pt-2">
      <div class="cardBloque p-2">
        <h1 class="titulo" [style]="'color:' + config?.primaryColor + ' !important; font-weight: 500'">
          {{ project?.name }}
        </h1>
        <h6 class="estado">
          {{ project?.location }}
        </h6>
        <h3 class="operation" [style]="'color:' + config?.primaryColor + ' !important;'">Proyecto</h3>
      </div>

      <div class="box-container">
        <swiper class="swiper-container" [config]="configSwal">
          <div *ngFor="let img of project?.Images" class="swiper-slide">
            <img [src]="img.url" alt="" />
          </div>
        </swiper>
      </div>

      <hr />

      <div class="cardBloque p-2 mb-2">
        <div class="col-12">
          <h3 class="text-center">Lo que ofrece este proyecto</h3>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <div *ngFor="let amenity of amenities" class="m-1">
                <img [src]="'assets/icon/IconBlue/' + amenity.amenity.icon" height="18" width="18" />
                &nbsp;
                <div [innerHTML]="amenity.amenity_id == 6 ? amenity.cantidad + '&nbsp;' : ''" class="amenity"></div>

                <div [innerHTML]="amenity.amenity.name" class="amenity"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cardBloque p-2 mb-2">
        <!-- Descripción -->
        <div class="col-12">
          <h3 class="column-title mrt-0" style="text-wrap: balance">Descripción</h3>
          <p style="text-wrap: pretty" [style.white-space]="'pre-line'">
            {{ project?.description }}
          </p>
        </div>
      </div>

      <!-- 3 Propiedades del proyecto (tomadas al azar) -->
      <div class="row">
        <div class="col-12 col-md-4 d-flex" *ngFor="let estate of random_estates">
          <div class="card flex-grow-1">
            <img
              class="card-img-top img-fluid"
              style="height: 15rem; object-fit: cover"
              [src]="
                estate?.files?.length > 0
                  ? estate?.files[0]?.url ?? 'assets/images/noImage.png'
                  : 'assets/images/noImage.png'
              "
              (error)="estate?.files[0].url = 'assets/images/noImage.png'"
              alt="Card image cap"
            />
            <div class="card-body">
              <h5 class="card-title">{{ estate.title }}</h5>
              <p class="card-text">
                {{ estate.description }}
              </p>
              <a
                (click)="goToDetalles(estate.property.id)"
                class="btn btn-primary"
                [style]="
                  'border-color:' +
                  config?.primaryColor +
                  ' !important;background-color:' +
                  config?.primaryColor +
                  ' !important;color:' +
                  config.secondaryColor +
                  ' !important;'
                "
                >Ver más</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Google maps -->
      <div class="row mt-2">
        <div class="col-12">
          <h3 class="column-title mb-1">Ubicación</h3>
          <div id="map"></div>
        </div>
      </div>

      <!-- Slider de layouts -->
      <div class="row mt-5">
        <div class="col-lg-12">
          <h3 class="mb-1">PLANOS DEL PROYECTO</h3>
        </div>
        <div class="col-lg-12">
          <app-building [config]="config"></app-building>
        </div>
        <div class="col-lg-12" *ngIf="building.length <= 0">
          <div class="row">
            <div class="buttons-lay pl-3" *ngFor="let layout of layouts">
              <button
                type="button"
                class="btn"
                [style]="
                  'border-color:' +
                  config?.primaryColor +
                  ' !important;' +
                  'background-color:' +
                  (layoutSelected === layout.id ? config?.primaryColor : 'transparent') +
                  ' !important;' +
                  'color:' +
                  (layoutSelected === layout.id ? config.secondaryColor : config?.primaryColor) +
                  ' !important;'
                "
                (click)="changeLay(layout.id)"
              >
                {{ layout.name }}
              </button>
            </div>
          </div>
          <app-layout *ngIf="building.length <= 0"></app-layout>
        </div>
      </div>

      <!-- Sección de propiedades -->
      <div class="cardBloque p-2 my-2">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <h3 class="column-title mb-1">Propiedades del Proyecto</h3>
          </div>
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th (click)="sortData('title')" style="cursor: pointer">
                      Nombre
                      <i
                        class="fa fa-sort"
                        [style]="'color:' + config?.primaryColor + ' !important;'"
                        aria-hidden="true"
                      ></i>
                    </th>
                    <th (click)="sortData('type')" style="cursor: pointer">
                      Tipo
                      <i
                        class="fa fa-sort"
                        [style]="'color:' + config?.primaryColor + ' !important;'"
                        aria-hidden="true"
                      ></i>
                    </th>
                    <th (click)="sortData('price')" style="cursor: pointer">
                      Precio
                      <i
                        class="fa fa-sort"
                        [style]="'color:' + config?.primaryColor + ' !important;'"
                        aria-hidden="true"
                      ></i>
                    </th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let estate of estates">
                    <td>{{ estate.title }}</td>
                    <td>{{ estate.type }}</td>
                    <td>
                      {{ estate.price ? (estate.price | currency) : "POR DEFINIR..." }}
                    </td>
                    <td>
                      <a
                        (click)="goToDetalles(estate.property.id)"
                        class="btn btn-outline-primary btn-sm"
                        [style]="
                          'border-color:' +
                          config?.primaryColor +
                          ' !important;' +
                          'background-color: transparent !important;' +
                          'color:' +
                          config?.primaryColor +
                          ' !important;'
                        "
                      >
                        <i class="fa fa-eye"></i>
                        Ver propiedad
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
              <div class="d-flex justify-content-between float-right m-1">
                <ngb-pagination
                  *ngIf="estates?.length > 0"
                  [collectionSize]="sizeTable"
                  [maxSize]="3"
                  [rotate]="true"
                  [(page)]="page"
                  [pageSize]="pageSize"
                  (pageChange)="getPageData()"
                  aria-label="Cambiar página"
                >
                  <ng-template ngbPaginationPrevious
                    ><span
                      [data-feather]="'chevron-left'"
                      [size]="18"
                      [class]="'font-weight-bolder text-primary'"
                    ></span>
                  </ng-template>
                  <ng-template ngbPaginationNext
                    ><span
                      [data-feather]="'chevron-right'"
                      [size]="18"
                      [class]="'font-weight-bolder text-primary'"
                    ></span>
                  </ng-template>
                </ngb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <app-footer class="mt-auto"> </app-footer>
</div>
